module.exports = __webpack_public_path__ + "static/media/marisa5.44a9ece6.mp3";